import React from 'react';
import {Container, Table} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeftLong, faFileLines} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";
import './Pagination.css'
import ApiService from "../../api/ApiService";
import CopyInfoModal from "../../components/CopyInfoModal";


const ChargingStandardList = () => {
    const navigate = useNavigate();
    const [data, setData] = React.useState([]); // 初始数据
    const [currentPage, setCurrentPage] = React.useState(1);
    const [hasMoreData, setHasMoreData] = React.useState(true); // 新增状态：是否有更多数据
    const [isFetching, setIsFetching] = React.useState(false); // 新增状态：是否正在获取数据
    const api = new ApiService();
    // 模拟数据请求函数
    const fetchMoreData = async () => {
        if (!hasMoreData || isFetching) return; // 如果没有更多数据或正在获取数据，直接返回

        setIsFetching(true); // 设置为正在获取数据

        const result = await api.nodeCostList();
        const newData = result.data;
        setData(prevData => [...prevData, ...newData]);
        setCurrentPage(prevPage => prevPage + 1);
        setIsFetching(false); // 重置为未获取数据状态
        setHasMoreData(false)

    };

    // 使用 Intersection Observer 监听元素是否进入视口
    const observer = React.useRef();
    const lastElementRef = React.useCallback(node => {
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMoreData && !isFetching) { // 只有在还有更多数据且未获取数据时才触发加载
                fetchMoreData();
            }
        });
        if (node) observer.current.observe(node);
    }, [hasMoreData, isFetching]);

    return (
        <Container>
            <div className={'pb-3'}>
                <div style={{alignItems: 'start', display: 'flex',}}>
                    <button style={{
                        color: '#101217',
                        border: 'none',
                        background: '#02C8E3',
                        borderRadius: '12px',
                        padding: '6px 22px',
                    }} onClick={() => {
                        navigate('/vipCenter?tab=PluginsPackages')
                    }}>
                        <span style={{marginRight: '10px'}}>
                            <FontAwesomeIcon icon={faArrowLeftLong} color={'#101217'} size={'1x'}/>
                        </span>
                        算力点
                    </button>
                </div>
                <div style={{background: '#15191E', padding: '24px', borderRadius: '20px',}}>
                    <h5 className={'mb-3'} style={{color: 'white', textAlign: 'start',}}>
                        <span>
                            <FontAwesomeIcon icon={faFileLines} color={'#02C8E3'} size={'1x'}/> 计费标准
                        </span>
                    </h5>
                    {data.map((item, index) => (
                        <div key={index} style={{
                            marginBottom: '20px',
                            padding: '16px',
                            borderRadius: '8px'
                        }}>
                            <div style={{
                                color: '#02C8E3',
                                fontSize: '16px',
                                padding:'8px',
                                textAlign: 'start',
                                backgroundColor: '#22272D',
                            }}>{item.title}</div>
                            <Table borderless={true} responsive="lg" variant="dark" style={{
                                minWidth: '700px',
                                background: "transparent",
                                '--bs-table-bg': 'transparent'
                            }}>
                                <thead>
                                <tr style={{background: '#22272D',paddingLeft:'16px',paddingBottom:'16px',}}>
                                    <th style={{textAlign: 'start', width: '36%'}}>插件</th>
                                    <th style={{textAlign: 'start', width: '12%'}}>用量</th>
                                    <th style={{textAlign: 'start', width: '12%'}}>价格</th>
                                    <th style={{textAlign: 'start', width: '20%'}}>VIP会员价格</th>
                                    <th style={{textAlign: 'start', width: '20%'}}>SVIP会员价格</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    item.children?.map((node, nodeIndex) => (
                                        <>
                                            <tr key={`header-${nodeIndex}`}>
                                                <td colSpan={5} style={{textAlign: 'start'}}>节点：{node.name}</td>
                                            </tr>
                                            <tr key={nodeIndex}>
                                                <td style={{
                                                    verticalAlign: 'middle',
                                                    textAlign: 'start',
                                                    width: '36%'
                                                }}>
                                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                                        <img src={node.icon} width={'52px'} height={'52px'}/>
                                                        <span style={{marginLeft: '10px'}}>{node.desc}</span>
                                                    </div>
                                                </td>
                                                <td style={{
                                                    verticalAlign: 'middle',
                                                    textAlign: 'start',
                                                    width: '12%'
                                                }}>{node.unit}</td>
                                                <td style={{
                                                    verticalAlign: 'middle',
                                                    textAlign: 'start',
                                                    width: '12%'
                                                }}>{node.price}</td>
                                                <td style={{
                                                    verticalAlign: 'middle',
                                                    textAlign: 'start',
                                                    color:'#02C8E3',
                                                    width: '20%'
                                                }}>{node.vipPrice}</td>
                                                <td style={{
                                                    verticalAlign: 'middle',
                                                    textAlign: 'start',
                                                    color:'#FF5656',
                                                    width: '20%'
                                                }}>{node.svipPrice}</td>
                                            </tr>
                                        </>
                                    ))
                                }
                                </tbody>
                            </Table>
                        </div>
                    ))}
                    {/* 观察目标元素 */}
                    {hasMoreData ? (
                        <div ref={lastElementRef} style={{textAlign: 'center', marginTop: '20px', color: 'white'}}>加载更多...</div>
                    ) : (
                        <div style={{textAlign: 'center', marginTop: '20px', color: 'white'}}>没有更多数据了</div>
                    )}
                </div>
            </div>
        </Container>
    );
};

export default ChargingStandardList;